// Presentation helpers for Work Order chips on the Technicians calendar.
//
// Status colours mirror the technician app's WOStatusComponent: each raw WO
// status maps to its own pill colour and label. See
// makani-technician-app/src/components/wo/status/wostatuscomponent.js.

// Pill styles + leading dot keyed by the raw WO status value.
export const WO_STATUS_UI = {
  0: { label: "Requested", chip: "bg-[#F5F5F5] text-[#404040]", dot: "bg-[#404040]" },
  1: { label: "Open", chip: "bg-[#FEF5C5] text-[#7C5402]", dot: "bg-[#7C5402]" },
  2: { label: "Enroute", chip: "bg-[#FDEEDA] text-[#C2410C]", dot: "bg-[#C2410C]" },
  3: { label: "Arrived", chip: "bg-[#E1F2F6] text-[#128D87]", dot: "bg-[#128D87]" },
  4: { label: "Parts", chip: "bg-[#F4E9FE] text-[#7E22CE]", dot: "bg-[#7E22CE]" },
  5: { label: "Completed", chip: "bg-[#E5F5E4] text-[#15803D]", dot: "bg-[#15803D]" },
  6: { label: "Reviewed", chip: "bg-[#EEF2FF] text-[#1D4ED8]", dot: "bg-[#1D4ED8]" },
  100: { label: "Billed", chip: "bg-[#E2E7F3] text-[#334155]", dot: "bg-[#334155]" },
  101: { label: "Closed", chip: "bg-[#FDE5E5] text-[#B91C1C]", dot: "bg-[#B91C1C]" },
};

export const woStatusUi = (status) => WO_STATUS_UI[status] ?? WO_STATUS_UI[0];

// Legend shown above the technicians grid.
export function WorkOrderLegend() {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 pb-4">
      {Object.values(WO_STATUS_UI).map(({ label, dot }) => (
        <div key={label} className="flex items-center gap-2">
          <span className={`inline-block w-3 h-3 rounded-[3px] ${dot}`} />
          <span className="font-OpenSansRegular text-[13px] leading-[18px] text-[#475569]">{label}</span>
        </div>
      ))}
    </div>
  );
}
